import { createContext, useState } from "react";
import rentalsService from "../services/rentals.service";
import UIkit from "uikit";

export const RentalsContext = createContext();
export const RentalsProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [upsertLoading, setUpsertLoading] = useState(false);
  const [rentals, setRentals] = useState([]);
  const [selectedFlags, setSelectedFlags] = useState([]);
  const [selectedRentals, setSelectedRentals] = useState([]);
  const [rental, setRental] = useState({});
  const [isNew, setIsNew] = useState(true);
  const [error, setPMSError] = useState(null);
  const [logs, setLogs] = useState([]);
  const [macroLogs, setMacroLogs] = useState([]);

  const [selectedTab, setSelectedTab] = useState(null);
  const [selectedSection, setSelectedSection] = useState(null);

  let rentalsCtx = {
    loading,
    setLoading,
    upsertLoading,
    setUpsertLoading,
    error,
    setPMSError,
    isNew,
    setIsNew,
    selectedFlags,
    setSelectedFlags,
    selectedRentals,
    setSelectedRentals,
    rental,
    setRental,
    rentals,
    setRentals,
    selectedTab,
    setSelectedTab,
    selectedSection,
    setSelectedSection,
    logs,
    setLogs,
    macroLogs,
    setMacroLogs,

    get: async () => {
      setLoading(true);
      return rentalsService
        .get()
        .then((resp, err) => {
          setLoading(false);
          setRentals(resp.data);
        })
        .catch((err) => {
          setLoading(false);
        });
    },

    getRental: async (id) => {
      setLoading(true);
      let result = await rentalsService.getRental(id);
      if (result.data) {
        setRental(result.data);
      }
      setLoading(false);
    },

    searchRentals: async (criteria) => {
      setLoading(true);
      const resp = await rentalsService.search(criteria);
      setRentals(resp.data);
      setLoading(false);
    },

    createRental: async (objRental) => {
      setUpsertLoading(true);
      try {
        let result = await rentalsService.create(objRental);
        if (result.data) {
          setRental(result.data);
          setRentals((prev) => [...prev, result.data]);
          setUpsertLoading(false);
          return result.data;
        }
      } catch (e) {
        if (e?.response?.data?.message) setPMSError(e.response.data.message);
        setUpsertLoading(false);
        return null;
      }
    },

    updateRental: async (rental_id, objRental) => {
      setUpsertLoading(true);
      try {
        let result = await rentalsService.update(rental_id, objRental);
        setUpsertLoading(false);
        setRental(result.data);
        if (result.data) {
          setRentals((prev) =>
            prev.map((item) =>
              +item.rental_id === +rental_id
                ? { ...result.data, updated_at: item.updated_at }
                : item,
            ),
          );
          return result.data;
        }
      } catch (e) {
        if (e?.response?.data?.message) setPMSError(e.response.data.message);
        setUpsertLoading(false);
        return null;
      }
    },

    deleteRental: async (id) => {
      setLoading(true);
      let index = rentals.findIndex((rental) => rental.rental_id == id);
      let result = await rentalsService.delete(id);
      if (result.data) {
        setRentals((prev) => [
          ...prev.slice(0, index),
          ...prev.slice(index + 1),
        ]);
      }
      setLoading(false);
    },

    createSection: (section) => {
      setLoading(true);
      return rentalsService
        .create_section(section)
        .then((res) => {
          setLoading(false);
          return [res.data, null];
        })
        .catch((err) => {
          setLoading(false);
          return [null, err];
        });
    },

    updateSection: async (section) => {
      setLoading(true);
      return rentalsService
        .update_section(section)
        .then((res) => {
          setLoading(false);
          return [res.data, null];
        })
        .catch((err) => {
          setLoading(false);
          return [null, err];
        });
    },

    deleteSection: async (id) => {
      setLoading(true);

      return rentalsService
        .delete_section(id)
        .then((res) => {
          setLoading(false);
          return [res.data, null];
        })
        .catch((err) => {
          setLoading(false);
          return [null, err];
        });
    },

    updateMacroValue: async (macroValue) => {
      return rentalsService
        .updateMacroValue(macroValue)
        .then((res) => {
          return [res.data, null];
        })
        .catch((err) => {
          return [null, err];
        });
    },

    getLogs: async (id) => {
      return rentalsService
        .logs(id)
        .then((res) => {
          setLogs(res.data);
        })
        .catch((err) => {
          return [null, err];
        });
    },

    getMacroLogs: async (id) => {
      return rentalsService
        .macro_logs(id)
        .then((res) => {
          setMacroLogs(res.data);
        })
        .catch((err) => {
          return [null, err];
        });
    },
  };

  return (
    <RentalsContext.Provider value={rentalsCtx}>
      {children}
    </RentalsContext.Provider>
  );
};
